// extracted by mini-css-extract-plugin
export default {"melodyVideo":"fM-z","isFullWidth":"gM-z","landingPageVideo":"hM-z","play":"iM-z","iframeVideo":"jM-z","playHidden":"kM-z","fullwidth":"lM-z"};